/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
export default function ContactsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.53846C5.32682 1.53846 1.53846 5.32682 1.53846 10C1.53846 14.6732 5.32682 18.4615 10 18.4615C14.6732 18.4615 18.4615 14.6732 18.4615 10C18.4615 5.32682 14.6732 1.53846 10 1.53846ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 6.15385C8.30066 6.15385 6.92308 7.53143 6.92308 9.23077C6.92308 10.9301 8.30066 12.3077 10 12.3077C11.6993 12.3077 13.0769 10.9301 13.0769 9.23077C13.0769 7.53143 11.6993 6.15385 10 6.15385ZM5.38462 9.23077C5.38462 6.68176 7.45099 4.61538 10 4.61538C12.549 4.61538 14.6154 6.68176 14.6154 9.23077C14.6154 11.7798 12.549 13.8462 10 13.8462C7.45099 13.8462 5.38462 11.7798 5.38462 9.23077Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 13.8462C8.86387 13.8462 7.74991 14.1607 6.7814 14.7547C5.8129 15.3486 5.02764 16.199 4.51255 17.2116C4.31994 17.5903 3.85684 17.7411 3.47817 17.5485C3.09951 17.3559 2.94868 16.8928 3.14129 16.5141C3.7851 15.2484 4.76659 14.1856 5.97711 13.4432C7.18763 12.7008 8.57997 12.3077 10 12.3077C11.42 12.3077 12.8124 12.7008 14.0229 13.4432C15.2334 14.1856 16.2149 15.2484 16.8587 16.5141C17.0513 16.8928 16.9005 17.3559 16.5218 17.5485C16.1432 17.7411 15.6801 17.5903 15.4874 17.2116C14.9724 16.199 14.1871 15.3486 13.2186 14.7547C12.2501 14.1607 11.1361 13.8462 10 13.8462Z"
        fill="currentColor"
      />
    </svg>
  )
}
